<template>
  <el-tooltip content="맵 표현 설정" placement="top">
    <el-popover
      placement="bottom"
      width="180"
      trigger="click"
      popper-class="topologymap-filter-popover">
      <el-row v-for="(item, index) in itemList" :key="index" type="flex" justify="space-between" align="middle" style="padding: 5px 0px;" v-if="item.enable">
        <el-col :span="6">
          <span>{{ item.name }}</span>
        </el-col>
        <el-col :span="18" style="text-align: right;">
          <el-checkbox-group v-model="item.value" v-if="item.key === 'layer'" @change="changeEvent(item)">
            <el-checkbox label="L2SW">L2</el-checkbox>
            <el-checkbox label="L3SW">L3</el-checkbox>
          </el-checkbox-group>
          <el-radio-group class="widget-type-toggle" v-model="item.value" size="mini" @change="changeEvent(item)" v-else>
            <el-tooltip content="설정한대로 보이기" placement="top" :open-delay="500" v-if="item.default === true">
              <el-radio-button label="DEFAULT"><img src="@/assets/img/icons/tplgy-default.png"></el-radio-button>
            </el-tooltip>
            <el-tooltip content="모두 보이기" placement="top" :open-delay="500">
              <el-radio-button label="SHOW"><img src="@/assets/img/icons/tplgy-show.png"></el-radio-button>
            </el-tooltip>
            <el-tooltip content="모두 숨기기" placement="top" :open-delay="500">
              <el-radio-button label="HIDE"><img src="@/assets/img/icons/tplgy-hide.png"></el-radio-button>
            </el-tooltip>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-button slot="reference" size="medium" type="content" class="topology-icon settings"></el-button>
      <!-- <el-button slot="reference" size="medium" type="content" style="color: #7E89A1;"><i class="fas fa-layer-group"></i></el-button> -->
    </el-popover>
  </el-tooltip>
</template>
<!-- <i class="fas fa-low-vision"></i>
<i class="fas fa-eye"></i>
<i class="fas fa-eye-slash"></i> -->

<script>
import { forEach, find } from 'lodash';
import { MapInfo } from '@/views/topologymap/js/maps';

export default {
  name: 'WFilterButton',
  components: {},
  data() {
    return {
      itemList: [
        {
          name: '라벨',
          key: 'label',
          value: 'DEFAULT',
          default: true,
          enable: true,
        },
        {
          name: '성능',
          key: 'rsc',
          value: 'DEFAULT',
          default: true,
          enable: true,
        },
        {
          name: '중요도',
          key: 'importance',
          value: 'DEFAULT',
          default: true,
          enable: true,
        },
        {
          name: '이벤트',
          key: 'event',
          value: 'DEFAULT',
          default: true,
          enable: true,
        },
        {
          name: '효과',
          key: 'animation',
          value: 'HIDE',
          default: false,
          enable: true,
        },
        {
          name: '회선',
          key: 'line',
          value: 'SHOW',
          default: false,
          enable: true,
        },
        {
          name: 'Layer',
          key: 'layer',
          value: ['L2SW', 'L3SW'],
          default: false,
          enable: false,
        },
      ],
    };
  },
  created() {
    forEach(this.itemList, (item) => {
      const key = `map.filter.${item.key}`;

      if (Object.prototype.hasOwnProperty.call(localStorage, key)) {
        if (item.key === 'layer') {
          item.value = localStorage.getItem(key).split(',');
        } else {
          item.value = localStorage.getItem(key);
        }
      } else {
        localStorage.setItem(key, item.value);
      }
    });

    MapInfo.getInstance(this).addMapCompleteCallback(this.visibleOptions);
  },
  methods: {
    visibleOptions() {
      const layerOption = find(this.itemList, ['key', 'layer']);
      layerOption.enable = window.filterLayerEnable === true;
    },
    changeEvent(item) {
      const key = `map.filter.${item.key}`;
      localStorage.setItem(key, item.value);

      MapInfo.getInstance(this).getGraph().graphModel.toDatas().forEach((model) => {
        if (model.updateResource) {
          model.updateResource(model.rscValue);
        }

        if (model.updateImportance) {
          model.updateImportance(model.legend.objImportance);
        }

        if (model.updateEvent) {
          model.updateEvent(model.eventStatus);
        }

        if (model.update) {
          model.update();
        }
      });
      MapInfo.getInstance(this).getGraph().invalidateVisibility();
    },
  },
};
</script>

<style lang="scss">
.topologymap-filter-popover {
  .el-radio-button__inner {
    border-color: #e0e0e0; //$selectedgray
    padding: 3px 8px 4px 8px;
    font-size: 14px;
    box-shadow: none!important;

  }
  .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    background-color: #eaf1f9 !important;
    border-color: #e0e0e0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/MapShowFilter.vue